import * as React from 'react';
import { UIText1 } from '@cian/ui-kit';
import * as style from './ReliableLabel.css';
import { Link } from '../Link';

interface IReliableLabelProps {
  onClick(event: React.MouseEvent<HTMLElement>): void;
  title: string;
}

export const ReliableBanner = ({ onClick, title }: IReliableLabelProps) => {
  return (
    <div className={style['container']} data-testid="ReliableBanner">
      <div className={style['logo-block']}>
        <div className={style['logo']}></div>
      </div>
      <div className={style['info-block']}>
        <UIText1>{title}</UIText1>
        <Link url={'#reliable'} onClick={onClick} linkStyle={style['link']}>
          Узнать больше
        </Link>
      </div>
    </div>
  );
};
